<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text" class="align-self-end pb-1">Portfolio Variance Report</h3>
  <div class="d-flex gap-8 pb-1 align-items-center">
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="getReport()"
            [disabled]="!selectedPortType || !selectedFcorg">
      Run Report
    </button>
  </div>
</div>
<div class="d-flex flex-row gap-8">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label class="asterisk--before">Portfolio Type</mat-label>
    <mat-select [(ngModel)]="selectedPortType" id="port-type-select" (selectionChange)="onPortTypeChange()">
      <mat-option *ngFor="let portType of portTypes" [value]="portType">
        {{ portType.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic" class="filter-options">
    <mat-label class="asterisk--before">Forecast Org</mat-label>
    <mat-select [(ngModel)]="selectedFcorg" id="mktAreaFilter">
      <mat-option [value]="'All'">All</mat-option>
      <mat-option *ngFor="let fcorg of fcorgs.options" [value]="fcorg">{{ fcorg }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
